import { CheckCircle2 } from "lucide-react";
import SectionHeader from "./SectionHeader";

const ABOUT_IMAGE = "https://images.pexels.com/photos/6773517/pexels-photo-6773517.jpeg";

const HIGHLIGHTS = [
    "US-registered wholesale & sourcing entity (Wyoming LLC)",
    "Supplier sourcing, verification & procurement support",
    "Founder-led operations with transparent communication",
    "Complete documentation on every transaction"
];

export default function About() {
    return (
        <section id="about" className="py-20 lg:py-28">
            <div className="container-px mx-auto max-w-7xl">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    <div className="lg:col-span-6 order-2 lg:order-1">
                        <div className="relative">
                            <div className="rounded-2xl overflow-hidden border border-border shadow-soft">
                                <img
                                    src={ABOUT_IMAGE}
                                    alt="Professional business partnership"
                                    className="w-full h-[460px] lg:h-[540px] object-cover"
                                    loading="lazy"
                                />
                            </div>
                            {/* Stat card */}
                            <div className="absolute -bottom-6 -right-2 sm:right-6 lg:-right-6 w-[78%] sm:w-72 rounded-xl bg-background border border-border shadow-elegant p-5">
                                <p className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground font-medium">
                                    Founded
                                </p>
                                <p className="mt-1 font-display text-3xl font-semibold text-foreground">
                                    2026
                                </p>
                                <p className="mt-2 text-sm text-muted-foreground leading-snug">
                                    A new, founder-led B2B wholesale operation — built on transparent communication and reliable sourcing.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-6 order-1 lg:order-2">
                        <SectionHeader
                            eyebrow="About Zaroor Global"
                            title="Helping businesses find and work with reliable suppliers worldwide."
                            description="Zaroor Global Trading LLC is a US-registered wholesale, Amazon sourcing and procurement company headquartered in Casper, Wyoming. Founded in 2026, we are a founder-led operation focused on supplier sourcing, verification, product research and end-to-end procurement support for brands, distributors and procurement teams worldwide."
                        />

                        <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                            {HIGHLIGHTS.map((item) => (
                                <li key={item} className="flex items-start gap-3">
                                    <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 shrink-0" />
                                    <span className="text-sm text-foreground/90 leading-relaxed">{item}</span>
                                </li>
                            ))}
                        </ul>

                        <div className="mt-10 grid grid-cols-3 gap-4 border-t border-border pt-8">
                            {[
                                { k: "Founder-led", v: "B2B operations" },
                                { k: "Reliable", v: "Sourcing & comms" },
                                { k: "Global", v: "Supplier network" }
                            ].map((s) => (
                                <div key={s.v}>
                                    <p className="font-display text-lg lg:text-xl font-semibold text-foreground leading-tight">{s.k}</p>
                                    <p className="mt-1 text-xs lg:text-sm text-muted-foreground">{s.v}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
